import { ElementRef } from '@angular/core';

import { SiteSelectOptions } from './site-select-options';
import { SiteRegularExpressions } from './site-regular-expressions';
import { SiteCascadingDropdowns } from './site-cascading-dropdowns';
import { SiteDateRanges } from './site-date-ranges';
import { SiteNumericRanges } from './site-numeric-ranges';
import { ISiteFormFieldConstraints } from './isite-form-field-constraints.interface';

/*
export interface ISiteConstraintsMap {
    [propertyName: string]: ISiteFormFieldConstraints;
}
*/
export interface IConstraintNameInputFieldMap {
    [propertyName: string]: ElementRef<HTMLInputElement>;
}

export class SiteFormFieldConstraints {
    public selectOptionsProperties: SiteSelectOptions = null;
    public regularExpressionProperties: SiteRegularExpressions = null;
    public cascadingDropdownProperties: SiteCascadingDropdowns = null;
    public dateRangeProperties: SiteDateRanges = null;
    public numericRangeProperties: SiteNumericRanges = null;

    public mapOfConstraintNameInputFields: IConstraintNameInputFieldMap = {};

    public readonly requireConstraintNames: boolean = true;
}
